<script lang="ts">
import { defineComponent, ref } from 'vue';
import type { AttributeWebCollection, AttributeWebItem, ProductVariation } from 'src/core/types/Products';

export default defineComponent({
  name: 'ProductListItem',

  props: {
    list: {
      required: true,
      default: [],
    },
    loading: Boolean,
    loadingLength: {
      type: Number,
      default: 1,
    },
    count: {
      required: false,
      type: Number,
      default: 0,
    },
    selectable: Boolean,
    selected: {
      type: Array as () => ProductVariation[],
      default: () => [],
    },
  },

  setup() {
    const selectList = ref([]);

    return {
      selectList,
    };
  },

  computed: {
    productList() {
      return this.list.slice(0, this.count || this.list.length);
    },
  },

  methods: {
    getProductFeatures(productAttrs: AttributeWebCollection, attrs: ProductVariation['attrs']) {
      const attrsArr: AttributeWebItem[] = [];

      Object.values(attrs).forEach((attr) => {
        const find = productAttrs.find((o) => o.code === Number(attr));
        if (find) {
          attrsArr.push(find);
        }
      });

      return attrsArr;
    },

    selectItem(product) {
      if (!this.selectList.includes(product)) {
        this.selectList.push(product);
      } else {
        const index = this.selectList.indexOf(product);
        this.selectList.splice(index, 1);
      }

      this.$emit('select', this.selectList);
    },
  },

  watch: {
    selected(newVal) {
      this.selectList = newVal;
    },
  },
});
</script>

<template>
  <div v-if="loading">
    <q-card :key="n" v-for="n in loadingLength">
      <q-card-section class="row q-pa-none">
        <div class="col-12 col-md-2 q-pa-md">
          <q-skeleton type="rect" width="100%" height="100px" animation-speed="450" />
        </div>
        <div class="col-12 col-md-10 column justify-between q-py-md q-pr-md">
          <div>
            <q-skeleton type="text" width="20%" animation-speed="450" />
            <q-skeleton type="text" width="50%" animation-speed="450" />
          </div>
          <q-skeleton type="text" width="25%" height="20px" animation-speed="450" />
          <div>
            <q-skeleton type="QToggle" width="40%" height="20px" animation-speed="450" />
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
  <div v-else>
    <q-item
      tag="a"
      :key="productKey"
      v-for="(product, productKey) in productList"
      v-bind="!selectable && { to: `/${product.link}` }"
      @click="selectItem(product)"
      clickable
      v-ripple
    >
      <q-item-section avatar v-if="selectable" class="flex justify-center items-center">
        <q-icon name="check" v-if="selectList.includes(product)" />
        <q-icon name="check_box_outline_blank" v-else />
      </q-item-section>
      <q-item-section avatar>
        <q-img :src="product.variations[0].images[0]" :ratio="16 / 9" width="150px" height="92px" />
      </q-item-section>
      <q-item-section>
        <q-item-label>
          <span class="text-weight-bold">{{ product.name }}</span>
        </q-item-label>
        <q-item-label caption>
          Özellikler:
          {{
            getProductFeatures(product.attributes, product.variations[0].attrs)
              .map((o) => o.name)
              .join(', ')
          }}
        </q-item-label>
        <q-item-label caption class="text-body1">{{ product.quantity }} adet</q-item-label>
        <q-item-label class="text-weight-bold">{{ $numberToCurrency(product.variations[0].price) }} ₺</q-item-label>
      </q-item-section>
    </q-item>
  </div>
</template>

<style scoped></style>
